import React from 'react';
import { NavLink } from 'react-router-dom';
import withLocale from '../../locale/withLocale';

const HeaderNavigation = ({ products, t, location }) => {
  return (
    <ul className="main-nav no-print">
      {products.map(item => {
        return (
          <li key={item.id}>
            <NavLink
              exact={item.url === '/' || item.exact}
              activeClassName="selected"
              to={item.url}
            >
              {t(item.text) || item.text}
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
};

export default withLocale(HeaderNavigation);



// WEBPACK FOOTER //
// ./src/common/jsx/layout/Header/HeaderNavigation.js